import React, {
  Component, Fragment, useEffect, useState,
} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Popconfirm, Drawer, notification,
  Checkbox,
} from 'antd';
import PropTypes from 'prop-types';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3FormInput from '@Uilib/h3FormInput';
import TenantActions from '@Actions/tenantActions';
import UserActions from '@Actions/userActions';
import MaskingPolicyActions from '@Actions/settings/maskingPolicyActions';
import H3Text from '@Uilib/h3Text';
import {
  CloseOutlined, PlusCircleFilled,
} from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import MaskingPolicyRuleForm from './MaskingPolicyRuleForm';
import './style.scss';

const MaskingPolicyForm = ({
  user, createMaskingPolicy, createMaskingPolicyLoading, callback, selectedMaskingPolicy, updateMaskingPolicy, updateMaskingPolicyLoading,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [data, setData] = useState([]);
  const [policyName, setPolicyName] = useState('');
  const [showAddMaskingPolicyRule, setShowAddMaskingPolicyRule] = useState(false);
  const [hideCostPrice, setHideCostPrice] = useState(false);
  const [hideSellingPrice, setHideSellingPrice] = useState(false);

  useState(() => {
    if (selectedMaskingPolicy) {
      setPolicyName(selectedMaskingPolicy?.data_masking_policy_name);
      setHideCostPrice(selectedMaskingPolicy?.hide_cost_price);
      setHideSellingPrice(selectedMaskingPolicy?.hide_selling_price);
      setData(selectedMaskingPolicy?.data_masking_policy_rules?.map((item) => ({
        key: uuidv4(),
        data_masking_policy_rule_id: item.data_masking_policy_rule_id,
        data_masking_policy_id: item.data_masking_policy_id,
        fieldName: item?.field_name,
        ruleType: item?.rule_type,
        ruleValue: item?.field_value,
      })));
    }
  }, []);

  const addNewRow = (changedData) => {
    const copyData = JSON.parse(JSON.stringify(data));
    copyData.push(changedData);
    setData(copyData);
  };

  const handleDelete = (key) => {
    // if (data?.length === 1) {
    //   setData([
    //     {
    //       key: uuidv4(),
    //       fieldName: '',
    //       ruleType: '',
    //       ruleValue: '',
    //     },
    //   ]);
    // } else {
    const copyData = data.filter((item) => item.key !== key);
    setData(copyData);
    // }
  };

  const columns = [
    {
      title: 'COLUMN NAME',
      width: '150px',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (record) => (
        <div>
          <H3FormInput
            value={record?.fieldName?.split(/[_.]/).join(' ').toProperCase()}
            disabled
            type="text"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName={(formSubmitted && !record?.fieldName) ? 'orgFormInputError' : 'orgFormInput'}
          />
        </div>
      ),
    },
    {
      title: 'RULE TYPE',
      width: '150px',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (record) => (
        <div>
          <H3FormInput
            value={record?.ruleType?.split(/[_]/).join(' ').toProperCase()}
            disabled
            type="text"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName={(formSubmitted && !record?.ruleType) ? 'orgFormInputError' : 'orgFormInput'}
          />
        </div>
      ),
    },
    {
      title: 'RULE VALUE',
      width: '150px',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (record) => (
        <div>
          <H3FormInput
            value={record?.ruleValue?.split(/[_]/).join(' ').toProperCase()}
            disabled
            type="text"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
          />
        </div>
      ),
    },
    {
      title: '',
      render: (text, record) => (
        <Fragment>
          {data.length !== record.key && (
            <div className="policy-form-delete-button" onClick={() => handleDelete(record.key)}>
              <CloseOutlined />
            </div>
          )}
        </Fragment>
      ),
      width: '40px',
      fixed: 'right',
    },
  ];

  const getDataSource = () => {
    const copyData = JSON.parse(JSON.stringify(data));

    return copyData;
  };

  const isDataValid = () => {
    let isValid = true;
    if (data?.length > 0) {
      for (let i = 0; i < data?.length; i++) {
        if (!data[i]?.fieldName || !data[i]?.ruleType || (data[i]?.ruleType !== 'HIDE' ? !data[i]?.ruleValue : false)) {
          isValid = false;
        }
      }
    } else {
      isValid = false;
      notification.error({
        message: 'A Masking Policy must include at least one Policy rule.',
        placement: 'top',
        duration: 4,
      });
    }
    return isValid;
  };

  const handleSubmit = () => {
    setFormSubmitted(true);

    // if (isDataValid() && policyName) {
    if (policyName) {
      if (selectedMaskingPolicy) {
        const payload = {
          org_id: user?.tenant_info?.org_id,
          data_masking_policy_id: selectedMaskingPolicy?.data_masking_policy_id,
          data_masking_policy_name: policyName,
          hide_cost_price: hideCostPrice,
          hide_selling_price: hideSellingPrice,
          data_masking_policy_rules: data.map((item) => ({
            data_masking_policy_id: selectedMaskingPolicy?.data_masking_policy_id,
            data_masking_policy_rule_id: item?.data_masking_policy_rule_id,
            field_name: item?.fieldName,
            rule_type: item?.ruleType,
            field_value: item?.ruleValue || '',
          })),
        };
        updateMaskingPolicy(payload, () => {
          callback();
        });
      } else {
        const payload = {
          data_masking_policy_name: policyName,
          hide_cost_price: hideCostPrice,
          hide_selling_price: hideSellingPrice,
          data_masking_policy_rules: data.map((item) => ({
            field_name: item?.fieldName,
            rule_type: item?.ruleType,
            field_value: item?.ruleValue || '',
          })),
        };
        createMaskingPolicy(payload, () => {
          callback();
        });
      }
    }
  };

  return (
    <Fragment>
      <div className="policy-form__wrapper">
        <div className="policy-form__header-wrapper">
          <div className="ant-row">
            <div className="ant-col-md-12">
              <div className="policy-form__input-row">
                <H3Text
                  text="Policy Name"
                  required
                  className="orgFormLabel"
                />
                <div className="policy-form__input-row__input">
                  <H3FormInput
                    name="vendor"
                    type="text"
                    containerClassName="orgInputContainer"
                    labelClassName="orgFormLabel"
                    inputClassName={(formSubmitted && !policyName) ? 'orgFormInputError' : 'orgFormInput'}
                    placeholder=""
                    onChange={(event) => {
                      setPolicyName(event.target.value);
                    }}
                    disabled={createMaskingPolicyLoading || updateMaskingPolicyLoading}
                    value={policyName}
                    maxlength="50"
                  />
                </div>
              </div>
            </div>
            <div className="ant-col-md-12" />
          </div>
        </div>

        <div className="policy-form__body-wrapper">
          <div className="ant-row">
            <div className="orgInputContainer ant-col-md-24">
              <Checkbox
                checked={hideCostPrice}
                onChange={(event) => {
                  setHideCostPrice(event.target.checked);
                }}
              >
                Hide Cost Price
              </Checkbox>
            </div>
          </div>
          <div className="ant-row">
            <div className="orgInputContainer ant-col-md-24">
              <Checkbox
                checked={hideSellingPrice}
                onChange={(event) => {
                  setHideSellingPrice(event.target.checked);
                }}
              >
                Hide Selling Price
              </Checkbox>
            </div>
          </div>
          <div className="ant-row">
            <div className="ant-col-md-24 show-table-header-in-mobile width-100-in-mobile">
              <Table
                columns={columns}
                loading={createMaskingPolicyLoading || updateMaskingPolicyLoading}
                dataSource={getDataSource(data) || []}
                size="small"
                pagination={false}
              />
            </div>
            <div className="ant-col-md-12">
              <div
                className="new-row-button"
                onClick={() => {
                  setShowAddMaskingPolicyRule(true);
                }}
              >
                <span className="new-row-button__icon">
                  <PlusCircleFilled />
                </span>
                <div>New Item</div>
              </div>
            </div>
          </div>
        </div>

        <div className="policy-form__footer-wrapper">
          <H3Button
            text={selectedMaskingPolicy ? 'Update Policy' : 'Add Policy'}
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            onClick={() => handleSubmit()}
            customClass="policy-form__account-submit"
            isLoading={createMaskingPolicyLoading}
            disabled={createMaskingPolicyLoading}
          />
        </div>

      </div>
      <Drawer
        open={showAddMaskingPolicyRule}
        onClose={() => {
          setShowAddMaskingPolicyRule(false);
        }}
        width="320px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '270px' }}>
            <H3Text text="Add Policy Rule" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowAddMaskingPolicyRule(false)} />
          </div>
        </div>
        <MaskingPolicyRuleForm
          callback={() => {
            setShowAddMaskingPolicyRule(false);
          }}
          data={data}
          updatedData={(changedData) => addNewRow(changedData)}
        />
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, MaskingPolicyReducers,
}) => ({
  user: UserReducers.user,
  createMaskingPolicyLoading: MaskingPolicyReducers.createMaskingPolicyLoading,
  updateMaskingPolicyLoading: MaskingPolicyReducers.updateMaskingPolicyLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getUsers: (tenantId, roleId) => dispatch(TenantActions.getUsers(tenantId, roleId)),
  createMaskingPolicy: (payload, callback) => dispatch(MaskingPolicyActions.createMaskingPolicy(payload, callback)),
  updateMaskingPolicy: (payload, callback) => dispatch(MaskingPolicyActions.updateMaskingPolicy(payload, callback)),
  getRoles: (tenantId) => dispatch(UserActions.getRoles(tenantId)),
  updateUser: (payload, callback) => dispatch(UserActions.updateUser(payload, callback)),
});

MaskingPolicyForm.propTypes = {
  user: PropTypes.func,
  createMaskingPolicyLoading: PropTypes.bool,
  updateMaskingPolicyLoading: PropTypes.bool,
  createMaskingPolicy: PropTypes.func,
  updateMaskingPolicy: PropTypes.any,
  selectedMaskingPolicy: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MaskingPolicyForm));
